// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes } from '@plesk/ui-library';
import { Link as RouteLink, matchPath } from 'react-router-dom';
import routes from './routes';

const Link = ({ to, ...props }) => {
    const pathname = to ? to.split('?')[0] : to;
    const isMatch = routes.some(route => matchPath(pathname, route));

    if (isMatch) {
        const pathRest = to.substr(pathname.length);
        const search = pathRest.split('#')[0];
        const hash = pathRest.substr(search.length);

        return <RouteLink to={{ pathname, search, hash }} {...props} />;
    }

    return <a href={to} {...props} />;
};

Link.propTypes = {
    to: PropTypes.string,
};

Link.defaultProps = {
    to: null,
};

export default Link;



// WEBPACK FOOTER //
// ./plesk/Link.js